/* src/app/common/components/logo/logo.component.scss */
:host {
  display: inline-block;
  font-size: 1rem;
}
.logo-container {
  font-size: inherit;
  display: flex;
  align-items: center;
}
.logo-container > * {
  padding: 0.5em;
}
.logo-container .logo {
  font-size: inherit;
}
.logo-container .logo .logo-image {
  width: 4em;
}
.logo-container .headings {
  font-size: inherit;
}
.logo-container .headings .title {
  font-size: 1.7em;
  line-height: 1em;
  font-family: "Staatliches";
  color: var(--ion-color-secondary);
  letter-spacing: 5px;
  vertical-align: text-top;
  text-align: left;
}
.logo-container .headings .title .dine {
  color: var(--ion-color-tertiary);
}
/*# sourceMappingURL=logo.component.css.map */
